import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ReviewDriverDayOffEntity } from '../../domain/entities/ReviewDriverDayOffEntity'

export class ReviewDriverDayOffModel extends ReviewDriverDayOffEntity {
  constructor(dataDto: ReviewDriverDayOffEntity) {
    super()
    mapEntityProperties<ReviewDriverDayOffEntity>(this, dataDto, {
      map: {
        startDate: toStartOfPlus3DayIso(dataDto.startDate),
        endDate: toEndOfPlus3DayIso(dataDto.endDate)
      }
    })
  }
}

function toStartOfPlus3DayIso(value?: Date | string | null) {
  if (!value) return undefined

  const d = new Date(value)
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0) - 3 * 3600 * 1000
  ).toISOString()
}

function toEndOfPlus3DayIso(value?: Date | string | null) {
  if (!value) return undefined

  const d = new Date(value)
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999) - 3 * 3600 * 1000
  ).toISOString()
}
